import { ArrowLeft, Send, Loader2 } from "lucide-react";
import { PAIN_POINTS, inputClass, labelClass } from "./constants";

// Step 2 (shown second): the optimisation brief. On submit we email this too.
export const BriefStep = ({ form, set, submitting, onBack, onSubmit }) => (
    <form
        data-testid="wizard-step-brief"
        onSubmit={onSubmit}
        className="space-y-6"
    >
        <div>
            <label className={labelClass}>Primary Pain Point</label>
            <select
                data-testid="pain-point-select"
                value={form.pain_point}
                onChange={(e) => set("pain_point", e.target.value)}
                className={`${inputClass} appearance-none cursor-pointer`}
            >
                <option value="" disabled>
                    Select your primary pain point…
                </option>
                {PAIN_POINTS.map((p) => (
                    <option key={p} value={p} className="bg-black text-white">
                        {p}
                    </option>
                ))}
            </select>
        </div>

        {form.pain_point && (
            <div className="reveal-field">
                <label className={labelClass}>
                    Please describe your specific operational bottleneck
                </label>
                <textarea
                    data-testid="bottleneck-textarea"
                    value={form.bottleneck}
                    onChange={(e) => set("bottleneck", e.target.value)}
                    rows={4}
                    placeholder="e.g. Our support team can't keep up with after-hours tickets…"
                    className={`${inputClass} resize-none`}
                />
            </div>
        )}

        <div className="flex gap-3 pt-2">
            <button
                type="button"
                data-testid="wizard-back"
                onClick={onBack}
                className="font-mono text-sm text-white/70 border border-white/15 px-5 py-4 rounded-lg inline-flex items-center gap-2 hover:border-white/40 hover:text-white transition-all"
            >
                <ArrowLeft size={16} />
                BACK
            </button>
            <button
                type="submit"
                data-testid="wizard-submit"
                disabled={submitting}
                className="group flex-1 font-mono text-sm tracking-[-0.01em] bg-neon text-black px-6 py-4 rounded-lg inline-flex items-center justify-center gap-2.5 hover:shadow-[0_0_26px_rgba(20,184,166,0.55)] transition-all disabled:opacity-60"
            >
                {submitting ? (
                    <>
                        <Loader2 size={16} className="animate-spin" />
                        TRANSMITTING…
                    </>
                ) : (
                    <>
                        TRANSMIT BRIEFING
                        <Send size={16} />
                    </>
                )}
            </button>
        </div>
    </form>
);
